import type { ButtonHTMLAttributes, ReactNode } from "react";
import s from "./Button.module.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "solid" | "ghost" | "subtle" | "danger";
  size?: "sm" | "md";
  children: ReactNode;
}

export function Button({ variant = "ghost", size = "md", className, children, ...rest }: ButtonProps) {
  const cls = [s.btn, s[variant], size === "sm" ? s.sm : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <button type="button" className={cls} {...rest}>
      {children}
    </button>
  );
}
